import {
  useCallback,
  useMemo,
  useState,
} from 'react';
import { useIntl } from 'react-intl';

import { Modal } from '@/core/components/Modal';
import { ButtonVariant } from '@/core/components/Button/Button.types';
import { globalMessages } from '@/core/messages/global.messages';
import { Loader } from '@/core/components/Loader';
import { Color } from '@/core/interfaces/common';

import { getBackendImage } from '@/utils/helpers';

import {
  MomentId,
  MomentsProps,
} from '../moments.types';
import {
  ViewMoreButton,
  Wrapper,
} from './Moments.styles';
import { Moment } from './Moment';
import { api } from '../api';
import { insertVariantCardsMoments } from '../helpers';

export const Moments = ({
  data,
  maxItems,
}: MomentsProps) => {
  const {
    formatMessage,
    locale,
  } = useIntl();

  const [
    isModalVisible,
    setIsModalVisible,
  ] = useState(false);

  const [
    selectedItem,
    setSelectedItem,
  ] = useState<MomentId>();

  const [
    momentsData,
    setMomentsData,
  ] = useState(data || []);

  const [
    currentPage,
    setCurrentPage,
  ] = useState(1);

  const [
    isLoading,
    setIsLoading,
  ] = useState(false);

  const handleShowMore = async () => {
    setIsLoading(true);

    try {
      const { data: resData } = await api.getMoments({
        locale,
        'pagination[page]': currentPage + 1,
        'pagination[pageSize]': 24,
      });

      setMomentsData([
        ...momentsData,
        ...resData.data as unknown as Array<MomentId>,
      ]);

      setCurrentPage(currentPage + 1);
    } finally {
      setIsLoading(false);
    }
  };

  const handleOpenModal = useCallback((item: MomentId) => {
    setSelectedItem(item);
    setIsModalVisible(true);
  }, []);

  const closeModal = useCallback(() => {
    setIsModalVisible(false);
  }, []);

  const increments = [
    6,
    3,
    3,
  ];
  const backgroundColors = [
    Color.BLUE,
    Color.GREEN,
    Color.YELLOW,
  ];

  const result = useMemo(() => (insertVariantCardsMoments({
    array: momentsData,
    backgroundColors,
    increments,
  }) as Array<MomentId>), [momentsData]);

  return (
    <>
      <Wrapper>
        {result?.map((item, key) => (
          <Moment
            components={data}
            handleOpenModal={handleOpenModal}
            item={item}
            key={item.id || `${item?.attributes?.backgroundColor}_${key}`}
          />
        ))}
        {selectedItem && (
          <Modal
            isOpen={isModalVisible}
            onRequestClose={closeModal}
            image={getBackendImage(
              selectedItem?.attributes?.image?.data.attributes.url
            )}
            title={selectedItem.attributes.popupTitle}
            content={selectedItem.attributes.text}
          />
        )}
      </Wrapper>
      {isLoading && <Loader />}
      {momentsData.length < maxItems && !isLoading && (
        <ViewMoreButton
          label={formatMessage(globalMessages.viewMore)}
          variant={ButtonVariant.GHOST}
          onClick={handleShowMore}
        />
      )}
    </>
  );
};
